import { gsap, ScrollTrigger } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger)

export function sticker(element: HTMLElement) {

  gsap.to(element, { duration: 0.5, autoAlpha: 1, ease: 'power2.out', delay: 2 })


  const rotate = gsap
    .timeline({
      scrollTrigger: {
        trigger: 'main',
        scrub: 0.2,
        start: 'top bottom',
        end: 'bottom top'
      }
    })
    .to(element, {
      rotation: 360 * 3,
      ease: 'none'
    })
}
